/**
 * =========================================================================================
 * Component - File-Progress-Bar
 * =========================================================================================
 * File-Progress-Bar
 **/

import React from 'react';

const FileProgressBar = (props) => {
    return (
        <React.Fragment>
            <div className={`u_progress-circle ${props.uploadPercentage === 100 ? 'u_progress-circle-loader' : ''}`} data-percentage={props.uploadPercentage ? props.uploadPercentage : 0}>
                <svg className="u_progress-circle__svg" viewport="0 0 2000 2000">
                    <circle className="u_progress-circle__stroke" r="50%" cx="50%" cy="50%"/>
                    <circle className="u_progress-circle__stroke" r="50%" cx="50%" cy="50%" style={{strokeDashoffset: `calc(314.1592% * (${props.uploadPercentage ? props.uploadPercentage : 0} / 100))`}}/>
                </svg>
                { props.uploadPercentage < 100 && <p className="u_percentage">{props.uploadPercentage}%</p> }
            </div>
        </React.Fragment>
    );
};

export default FileProgressBar;